import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.css'],
})
export class AvatarComponent {
  @Input() imageUrl: string;
  @Input() nick: string;
  @Input() size: string;
  @Input() title: string;
  @Input() disabled = false;
  imageLoadError = false;

  handleImageError() {
    this.imageLoadError = true;
  }
}
